module.exports = __webpack_public_path__ + "b.no1.2f35430b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/b.no1.jpg
// module id = Y/24
// module chunks = 0